import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipe',
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(value: Array<{ 'code': string, 'descripcion': string }>, args?: string): any {
    if (value === undefined) {
      return null;
    } else if (args != undefined && args.length >= 4) {
      if (args === undefined) {
        return value;
      } else {
        let result = value.filter(x => x.code.includes(args) || x.descripcion.toLowerCase().includes(args.toLowerCase()));
        return result;
      }
    } else {
      return value;
    }
  }

}
